module.exports = __webpack_public_path__ + "static/media/banner-bg.1b0836fa.svg";